import React, { useEffect, useState } from "react";
import BreadCrumbComp from "../../../components/breadCrumb";
import FormTextField from "../../../components/textField/formTextField";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import LaddaButton from "../../../components/buttons/laddaButton";
import {
  addOrUpdateNationalSuppliers,
  callApiAsync
} from "../../../services/apiService";
import { useLocation, useNavigate } from "react-router-dom";
import { canManageNationalSuppliers } from "../../../constants/supplierRoles";

const CreateNationalSuppliers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location.state?.data;

  const userData = useSelector((state) => state.userData.userData);
  const isSupplierManagment = canManageNationalSuppliers(userData.roleList);

  const validationSchema = yup.object().shape({
    supplier_name: yup.string().required("Nombre requerido"),
    nit_rut: yup.string().required("NIT requerido"),
    address: yup.string().required("Dirección requerida"),
    city: yup.string().required("Ciudad requerida"),
    winery_address: yup.string().required("Dirección de la Bodega requerido"),
    contact_name: yup.string().required("Nombre de contacto requerido"),
    phone: yup
      .string()
      .matches(/^\d+$/, "Debe ser un número")
      .required("Teléfono requerido"),
    email: yup.string().email("Correo inválido").required("Correo requerido"),
    financial_statement_url: yup.string().required("URL requerida")
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onSubmit"
  });

  const setValues = (data) => {
    setValue("supplier_name", data.supplier_name || "");
    setValue("nit_rut", data.nit_rut || "");
    setValue("address", data.address || "");
    setValue("city", data.city || "");
    setValue("winery_address", data.winery_address || "");
    setValue("contact_name", data.contact_name || "");
    setValue("phone", data.phone || "");
    setValue("email", data.email || "");
    setValue("financial_statement_url", data.financial_statement_url || "");
  };

  const onSubmit = async (data) => {
    const payload = {
      id: rowData ? rowData.id : 0,
      ...data,
      creator_user_id: userData.id
    };

    await callApiAsync(
      () => addOrUpdateNationalSuppliers(payload),
      () => {
        navigate("/suppliers/suppliers_national");
      }
    );
  };

  useEffect(() => {
    if (rowData && rowData.id !== 0) {
      setValues(rowData);
    }
  }, [rowData]);

  return (
    <div>
      <BreadCrumbComp />
      <div className="searchTitle">
        <h1>
          {rowData?.id == 0 ? "CREAR NUEVO" : "EDITAR"} PROVEEDOR FARMACÉUTICO
          NACIONAL
        </h1>
      </div>
      <div className="table-container">
        <h1 className="title-bio-details-chard vm-20">
          Proveedor Farmacéutico Nacional
        </h1>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Nombre del Proveedor*:</p>
            <FormTextField
              name="supplier_name"
              control={control}
              error={errors.supplier_name}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">NIT*:</p>
            <FormTextField
              name="nit_rut"
              control={control}
              error={errors.nit_rut}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Dirección Principal*:</p>
            <FormTextField
              name="address"
              control={control}
              error={errors.address}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Ciudad*:</p>
            <FormTextField
              name="city"
              control={control}
              error={errors.city}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Dirección de la Bodega*:</p>
            <FormTextField
              name="winery_address"
              control={control}
              error={errors.winery_address}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Nombre de Contacto*:</p>
            <FormTextField
              name="contact_name"
              control={control}
              error={errors.contact_name}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Teléfono*:</p>
            <FormTextField
              name="phone"
              control={control}
              error={errors.phone}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Correo Electrónico*:</p>
            <FormTextField
              name="email"
              control={control}
              error={errors.email}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <p className="create-label ml-0">Link Estado Financiero*:</p>
            <FormTextField
              name="financial_statement_url"
              control={control}
              error={errors.financial_statement_url}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
        </Grid>

        <br />
        {isSupplierManagment && (
          <div className="HContainer j-center w-complete">
            <LaddaButton
              variant="contained"
              onClick={(e) => handleSubmit(onSubmit)(e)}
            >
              <div className="HContainer align-center">
                <p className="button_text">
                  {rowData?.id == 0 ? "Crear" : "Editar"} Proveedor Farmacéutico Nacional
                </p>
              </div>
            </LaddaButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateNationalSuppliers;
